import { SET_EXAM_DATA } from 'redux/reducers/exam/action-types';

const SHORT_TEXT_QUESTION_REDUCER = (state, action) => {
    switch (action.type) {
        case SET_EXAM_DATA:
            return state.set('answerText', action.data['ANSWERTEXT'] || '');
        default:
            return state;
    }
};

export { SHORT_TEXT_QUESTION_REDUCER };
